/**
 * A page-list schema is a link form when the schema actually used for add or
 * edit opens on its own page. Flat schemas keep display on the root object.
 * Split schemas keep it on add and edit, and those override the root.
 */
export function formSchemaUsesLinkDisplay(formSchema, linkMode) {
  if (formSchema == null || linkMode == null) return false;

  const resolved = (mode) =>
    (mode === "add" ? formSchema.add : formSchema.edit) ?? formSchema;

  return [resolved("add"), resolved("edit")].some(
    (schema) => schema?.display?.mode === linkMode
  );
}
